"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//@ts-ignore
const Clipboardcopy_1 = __importDefault(require("./Clipboardcopy"));
const DISCORD_LINK = "https://discord.gg/snaCqTKmGv";
const PHONE_NUMBER = "(669)-333-2228";
function Contact() {
    return (react_1.default.createElement("div", { className: "flex flex-col sm:flex-row sm:justify-center sm:items-center bg-color-background-default border-black w-full py-6 px-4" },
        react_1.default.createElement("a", { href: DISCORD_LINK, className: "mb-4 sm:mb-0 sm:mr-4" },
            react_1.default.createElement("button", { className: "bg-green-900 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm sm:text-base" },
                "Contact Me ",
                react_1.default.createElement("br", null),
                " [Discord Link Click Here]")),
        react_1.default.createElement("div", { className: "flex items-center space-x-4 sm:space-x-2" },
            react_1.default.createElement("div", { className: "text-white text-center sm:text-left" },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "@"))),
            react_1.default.createElement(Clipboardcopy_1.default, { toClipText: DISCORD_LINK }),
            react_1.default.createElement("div", { className: "text-white" }, "or"),
            react_1.default.createElement(Clipboardcopy_1.default, { toClipText: PHONE_NUMBER }))));
}
exports.default = Contact;
